import {
  PSMApiRequestService,
  PSMRequestOption,
} from '../framework/request/PSMApiRequestService'

export type Req<T> = { accountIdHeader: string | number } & T

type ParamsOf<F> = F extends (arg0: infer Params0) => unknown ? Params0 : never
type ResultOf<F> = F extends (arg0: ParamsOf<F>) => infer Result ? Result : never

const getPSMApiService = <ApiTypeMap extends { [key: string]: unknown }>(
  apiMap: {
    [key in keyof ApiTypeMap]: Partial<PSMRequestOption>
  },
  option: Partial<PSMRequestOption>,
) => {
  const service = new PSMApiRequestService(apiMap, {
    ...option,
    formatAxiosOption: (config) => ({
      ...config,
      headers: {},
    }),
  })

  return service.getServiceInstance() as {
    [key in keyof ApiTypeMap]: (
      params?: ParamsOf<ApiTypeMap[key]>,
      requestConfig?: Partial<PSMRequestOption>,
    ) => Promise<ResultOf<ApiTypeMap[key]>>
  }
}

export { getPSMApiService }
